import React from 'react';
import classnames from 'clsx';
import { useIntl } from 'react-intl';

import { FlexColumn } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import { ImageTypes } from './contants';
import styles from './layout-image.module.css';

/**
 * @typedef {import('./contants').ImageType} ImageType
 */
/**
 * @param {object} props - component props
 * @param {ImageType} [props.secondImageType] - indentifies the type of the second image
 * @returns {JSX.Element}
 */
export const LandscapeImage = ({ secondImageType = ImageTypes.Label }) => {
  const intl = useIntl();
  const firstImageType = ImageTypes.Label;

  return (
    <div className={styles.container}>
      <FlexColumn className={styles['images-container']}>
        <div className={styles['image-container']}>
          <img alt={intl.formatMessage(firstImageType.text)} className={styles['landscape-image']} src={firstImageType.image.landscape} />
          <div className={styles['text-container']}>
            <Text className={classnames(styles.text, styles['landscape-text'])} textType={TextType.Caption} value={firstImageType.text} />
          </div>
        </div>

        <div className={styles['image-container']}>
          <img alt={intl.formatMessage(secondImageType.text)} className={styles['landscape-image']} src={secondImageType.image.landscape} />
          <div className={styles['text-container']}>
            <Text className={classnames(styles.text, styles['landscape-text'])} textType={TextType.Caption} value={secondImageType.text} />
          </div>
        </div>
      </FlexColumn>
    </div>
  );
};
